<p>
  {{data | json}}
</p>
